import { Component } from 'react'
import * as styles from 'components/features/pfm/VideoPlayer/VideoPlayer.styl'
import { ImageURLs } from 'interfaces/media'
import { LazyRender } from 'components/features/pfm/LazyRender/LazyRender'
import ReactPlayer from 'react-player'
import * as debounce from 'lodash/debounce'
import { IS_MOBILE } from 'helpers/userAgentHelpers'
import { VideoLayout } from 'components/features/pfm/VideoLayout/VideoLayout'

const MINUTE = 60000

type VideoPlayerProps =
  & {
    poster: ImageURLs | null
    videoUrl?: string
    onError?: () => void
  }

type VideoPlayerState = {
  isLoading: boolean
  isLoaded: boolean
}

class VideoPlayer extends Component<VideoPlayerProps, VideoPlayerState> {
  static defaultProps: Partial<VideoPlayerProps> = {
    poster: null,
  }

  state = {
    isLoading: IS_MOBILE,
    isLoaded: false,
  }

  render () {
    const {
      poster,
      videoUrl,
    } = this.props

    const {
      isLoaded,
      isLoading,
    } = this.state

    return (
      <div className={ styles.container }>
        <VideoLayout
          poster={ poster }
          isLoaded={ isLoaded }
          isLoading={ isLoading }
          onPlay={ this.handlePlay }
        >
          { (isLoading || isLoaded) && videoUrl &&
            <LazyRender permanent margin={ 500 } className={ styles.fullSize }>
              <ReactPlayer
                url={ videoUrl }
                playing={ !IS_MOBILE }
                width='100%'
                height='100%'
                playsinline
                controls
                config={{
                  youtube: {
                    playerVars: { origin: `${ location.protocol }//${ location.host }` },
                  },
                }}
                onReady={ this.handleLoad }
                onError={ this.handleError }
              />
            </LazyRender>}
        </VideoLayout>
      </div>
    )
  }

  componentDidMount () {
    const { isLoading } = this.state
    if (isLoading) {
      this.handleLoadTimeout()
    }
  }

  componentDidCatch () {
    this.handleLoadTimeout.cancel()
    this.handleError()
  }

  componentWillUnmount () {
    this.handleLoadTimeout.cancel()
  }

  private handlePlay = () => {
    this.handleLoadTimeout()
    this.setState({
      isLoading: true,
    })
  }

  private handleLoad = () => {
    this.handleLoadTimeout.cancel()
    this.setState({
      isLoaded: true,
      isLoading: false,
    })
  }

  private handleError = () => {
    this.setState({
      isLoading: false,
    })
    this.props.onError && this.props.onError()
  }

  private handleLoadTimeout = debounce(this.handleError, MINUTE)
}

export default VideoPlayer
